import BaseModal from "../common/HPBaseModal";
import SyncIcon from "@mui/icons-material/Sync";
import { ModalProps } from "../../_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface RefreshModalProps extends ModalProps {
  surveysCount: number;
  action: () => void;
}
const RefreshSelectedSurveysModal: React.FC<RefreshModalProps> = ({
  surveysCount,
  action,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  return (
    <BaseModal
      title="Refresh multiple surveys?"
      message={`You are about to refresh ${surveysCount} surveys. Continue?`}
      onConfirm={action}
      onCancel={closeTopModal}
      confirmButtonText="Refresh"
      cancelButtonText="Cancel"
      confirmButtonIcon={<SyncIcon className="text-hp-bg-primary" />}
    />
  );
};

export default RefreshSelectedSurveysModal;
